import {
  Autocomplete,
  Checkbox,
  Grid,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import { vehicalCheckListOption, yesNoOption } from '../Data/HFDropDowdData';
import { vehicalInspectionList } from '../Data/HfInputFieldsData';
import { EmployeeNameField } from 'routes/Pages/GenTask/components/SharedFormFields';
const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};
const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};
const HFClockinForm = ({
  currentClockInData,
  setCurrentClockInData,
  spList,
  spListObj,
  currentVehicalCheckList,
  setCurrentVehicalCheckList,
  machineList,
}) => {
  const combinedMachineOptions = React.useMemo(() => {
    const all = machineList.flatMap(group => group.values);
    return Array.from(new Set(all)); // dedupe
  }, [machineList]);

  const handleChnageclockinData = (name, value) => {
    let updatedData = {
      [name]: value,
    };
    if (name === 'doYouDriveACompanyVan') {
      if (value === 'No') {
        updatedData['vanRegistration'] = '';
      }
    }
    setCurrentClockInData(prevData => ({
      ...prevData,
      ...updatedData,
    }));
  };
  const handleVehicalCheckListChange = (name, value) => {
    setCurrentVehicalCheckList(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };
  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
      }}>
      <EmployeeNameField value={currentClockInData['employeeName']} onChange={handleChnageclockinData} isOperator={true} />
      <InputFields
        label="Date & Time"
        helperText={'Enter Clock in Date & Time'}
        name="date_Time"
        required={true}
        value={currentClockInData['date_Time']}
        textFieldType={'datetime-local'}
        width={4}
        handleIpChange={handleChnageclockinData}
      />
      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Do you drive a Company Van?
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'doYouDriveACompanyVan'}
          value={currentClockInData['doYouDriveACompanyVan'] || null}
          options={yesNoOption}
          onChange={(event, newValue) => handleChnageclockinData('doYouDriveACompanyVan', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      <InputFields
        label="Van Registration"
        helperText={'Enter Van Registration'}
        name="vanRegistration"
        required={currentClockInData['doYouDriveACompanyVan'] === 'Yes'}
        value={currentClockInData['vanRegistration']}
        textFieldType={'text'}
        width={4}
        handleIpChange={handleChnageclockinData}
        disabled={currentClockInData['doYouDriveACompanyVan'] !== 'Yes'}
      />

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Machine
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'machine'}
          value={currentClockInData['machine'] || null}
          options={combinedMachineOptions}
          onChange={(event, newValue) => handleChnageclockinData('machine', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Forest or SP Number
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'forestSPNumber'}
          value={currentClockInData['forestSPNumber'] || null}
          options={spListObj ? Object.keys(spListObj) : []}
          onChange={(event, newValue) => handleChnageclockinData('forestSPNumber', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <InputFields
        label="Additional Information"
        name="additionalInformation"
        required={false}
        value={currentClockInData['additionalInformation']}
        textFieldType={'text'}
        multiline={true}
        width={12}
        handleIpChange={handleChnageclockinData}
      />
      {currentClockInData['doYouDriveACompanyVan'] === 'Yes' && (
        <>
          <Grid item xs={6} sm={6} md={12}>
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: '10px', // Rounded corners
                overflow: 'hidden', // Ensures children don’t overflow borderRadius
                boxShadow: 1, // Optional: adds a shadow
              }}>
              <Table border={1} size="small" sx={{ border: '1px solid #ccc', fontSize: '0.825rem' }}>
                <TableHead
                  sx={{
                    '& .MuiTableRow-root td:first-child': {
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                    },

                    '& .MuiTableRow-root td:last-child': {
                      borderTopRightRadius: '10px',

                      borderBottomRightRadius: '10px',
                    },
                  }}>
                  <TableRow>
                    <TableCell width="70%"></TableCell>
                    <TableCell>Choose Defect or Repaired</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {vehicalInspectionList.map((item, index) => {
                    return (
                      <TableRow key={`${index}_${item.label}`}>
                        <TableCell>{item.label}</TableCell>
                        <TableCell>
                          <Autocomplete
                            size="small"
                            disablePortal
                            name={item.key}
                            value={currentVehicalCheckList[item.key] || null}
                            options={vehicalCheckListOption}
                            onChange={(event, newValue) => handleVehicalCheckListChange(item.key, newValue)}
                            sx={{ fontSize: '0.8rem' }}
                            renderInput={params => <TextField {...params} size="small" fullWidth />}
                            fullWidth
                            slotProps={{
                              ...autoCompleteSlotProps,
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Typography variant="subtitle2">Confirm you have completed the Van Driver Walk-Around Check Sheet</Typography>
              <Checkbox
                required
                checked={currentClockInData['haveCompletedVanDriverWalkAroundCheckSheet']}
                onChange={e => handleChnageclockinData('haveCompletedVanDriverWalkAroundCheckSheet', e.target.checked)}
              />
            </div>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default HFClockinForm;
